export {
  quoteStatusBrokerMeta,
  quoteStatusContactMeta,
} from './lib/quote-status-meta';

export { QuoteStatusIconPipe } from './lib/quote-status-icon.pipe';
export { QuoteStatusDescriptionPipe } from './lib/quote-status-description.pipe';
export { QuoteStatusColorPipe } from './lib/quote-status-color.pipe';
export { QuoteStatusPipesModule } from './lib/quote-status-pipes.module';
